var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenIconGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.56522 -0.000244141C6.98896 -0.000244141 6.52174 0.466973 6.52174 1.04323C6.52174 1.61949 6.98896 2.08671 7.56522 2.08671H8.4375L5.5231 5.00111C5.11562 5.40859 5.11562 6.06918 5.5231 6.47666C5.72658 6.68014 5.994 6.78236 6.26087 6.78236C6.52774 6.78236 6.79516 6.68014 6.99864 6.47666L9.91304 3.56226V4.43454C9.91304 5.0108 10.3803 5.47802 10.9565 5.47802C11.5328 5.47802 12 5.0108 12 4.43454V1.04323C12 0.466973 11.5328 -0.000244141 10.9565 -0.000244141H7.56522ZM2.34783 0.521495C1.05313 0.521495 0 1.57489 0 2.86932V9.65193C0 10.9464 1.05313 11.9998 2.34783 11.9998H9.13043C10.4251 11.9998 11.4783 10.9464 11.4783 9.65193V8.54323C11.4783 7.96697 11.011 7.49976 10.4348 7.49976C9.85852 7.49976 9.3913 7.96697 9.3913 8.54323V9.65193C9.3913 9.79567 9.27444 9.9128 9.13043 9.9128H2.34783C2.20383 9.9128 2.08696 9.79567 2.08696 9.65193V2.86932C2.08696 2.72558 2.20383 2.60845 2.34783 2.60845H3.45652C4.03278 2.60845 4.5 2.14123 4.5 1.56497C4.5 0.988712 4.03278 0.521495 3.45652 0.521495H2.34783Z",
    fill: "#9E9288"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenIconGray);
export default __webpack_public_path__ + "static/media/open-icon-gray.7a977d8600b1c4ca5940ff3a90f4c885.svg";
export { ForwardRef as ReactComponent };